import React, { Component, Fragment } from "react";
import { Image, Container } from "react-bootstrap";
import { connect } from "react-redux";
import Dropdown, { Group } from "react-dropdown";

import SelectOption from "../../../components/UI/SelectOption/SelectOption";
import Input from "../../../components/UI/Input/Input";
import Button from "../../../components/UI/Button/Button";
import ButtonAddon from "../../../components/UI/ButtonAddon/ButtonAddon";
import * as procedureActions from "../../../store/actions/index";
import Questionnaire from "../Questionnaire/Questionnaire";
import Spinner from "../../../components/UI/Spinner/Spinner";
import "react-dropdown/style.css";
import NumberFormat from "react-number-format";

import classes from "./ProcedureSearch.module.css";

import cart from "../../../assets/images/icon-cart-small.svg";
interface IParentProps {
  goBackHandler: () => void;
}
interface IStateFromProps {

  beneficiaryDetails: {
    primaryAccountHolder: boolean;
    patientName: string;
    patientId: number;
    dateOfBirth: string;
  
  }[];
  procedureDetails: {
    procedureType: string;
    procedures: {
      procedureId: string;
      procedure: string;
    }[];
  }[];
  loadingBeneficiaryDetails:boolean;
  t:any;
}
interface IDispatchFromProps {
  onFetchBalanceBillingBeneficiaryDetails: (userId: string) => void;
  onFetchProcedureDetails: () => void;
}
type Props = IParentProps & IStateFromProps & IDispatchFromProps;
class ProcedureSearch extends Component<Props> {
  state = {
    travelDistance: 30,
    changeMilesBy: 5,
    beneficiarySelected: "Select",
    errorBeneficiarySelected: "",
    procedureId: "Select",
    errorProcedureId: "",
    postalCode: "",
    errorPostalCode: "",
    procedure: "",
    physicianName: "",
    errorPhysicianName: "",
    physicianPhone: "",
    errorPhysicianPhone: "",
    physicianEmail: "",
    errorPhysicianEmail: "",
    formValid: false,
    procedureFormData: "",
    submitted: false,
  };

  componentDidMount() {
    const userId = localStorage.getItem("userId");
    if (userId !== null) {
      this.props.onFetchBalanceBillingBeneficiaryDetails(userId);
      this.props.onFetchProcedureDetails();
    } else {
      this.setState({ errorUserId: true });
    }
  }
  handleMinusDistance = () => {
    const { travelDistance, changeMilesBy } = this.state;
    console.log(travelDistance);
    this.setState({
      travelDistance: travelDistance - changeMilesBy,
    });
  };
  handlePlusDistance = () => {
    const { travelDistance, changeMilesBy } = this.state;
    console.log(travelDistance);
    this.setState({
      travelDistance: travelDistance + changeMilesBy,
    });
  };
  handleChange = (e) => {
    this.setState({ formValid: false });
    this.setState({
      [e.target.name]: e.target.value,
      errorProcedureId: "",
      errorPostalCode: "",
      errorPhysicianName: "",
      errorPhysicianPhone: "",
      errorPhysicianEmail: "",
    });
    console.log(this.state.physicianPhone);
  };
  procedureHandleChange = (e) => {
    this.setState({
      procedureId: e.value,
      errorProcedureId: "",
    });
  };
  beneficiaryHandleChange = (e) => {
    this.setState({
      beneficiarySelected: e.value,
      errorBeneficiarySelected: "",
    });
  };
  validateForm = () => {
    // let beneficiarySelected = this.state.beneficiarySelected;
    let procedureId = this.state.procedureId;
    let postalCode = this.state.postalCode;
    let physicianName = this.state.physicianName;
    let physicianPhone = this.state.physicianPhone;
    let physicianEmail = this.state.physicianEmail;
    let formIsValid = true;
    const {t} = this.props;

    if (procedureId === "Select") {
      formIsValid = false;
      // console.log("hiiiiiiii",t('errorMsg.selectProcedureError'));
      
      this.setState({
        errorProcedureId: t('errorMsg.selectProcedureError'),
      });
    }
    let regex = /^[0-9]{5}$/;
    if (postalCode && !regex.test(this.state.postalCode)) {
      formIsValid = false;
      this.setState({
        errorPostalCode:t('findProviderPage.errorPostalCode'),
      });
    }
    if (physicianName && !physicianName) {
      formIsValid = false;
      this.setState({
        errorPhysicianName: t('errorMsg.validName'),
      });
    }
    let phonePattern = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/; // (123) 123-1234;

    if (physicianPhone && !phonePattern.test(physicianPhone)) {
      formIsValid = false;
      this.setState({
        errorPhysicianPhone: t('errorMsg.errorPhone'),
      });
    }
    let emailPattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    if (
      physicianEmail &&
      !emailPattern.test(String(physicianEmail).toLowerCase())
    ) {
      formIsValid = false;
      this.setState({
        errorPhysicianEmail: t('errorMsg.errorEmail'),
      });
    }
    return formIsValid;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitted: true });
    if (this.validateForm()) {
      this.setState({ formValid: true });

      const {
        travelDistance,
        procedureId,
        postalCode,
        physicianName,
        physicianPhone,
        physicianEmail,
      } = this.state;

      let physicianPhoneNum = physicianPhone.replace(/[^0-9]/g, "");

      const formData = {
        travelDistance,
        procedureId,
        preferredLocation: {
          type: "Zip",
          value: postalCode,
        },
        referingPhysicianName: physicianName,
        referingPhysicianPhone: physicianPhoneNum,
        referingPhysicianEmail: physicianEmail,
      };
      console.log(formData);
      this.setState({
        procedureFormData: formData,
      });
    }
  };
  render() {
    const { t } = this.props;
    const { goBackHandler, beneficiaryDetails, procedureDetails } = this.props;
    const nextBtnStyle = {
      marginTop: "10px",
    };
    const elementLabelStyle = {
      fontSize: "13px",
      fontWeight: "600",
      color: "#117093",
      marginBottom: "3px",
    };
    const elementInputStyle = {};
    const elementLabelStyleHide = {
      display: "none",
    };
    let benificiaries = ["Select"];
    if (beneficiaryDetails) {
      benificiaries = benificiaries.concat(
        beneficiaryDetails
          .map((res) => res.patientName)
          .filter((val) => val)
      );
    }

    let spinner:any;
    if(this.props.loadingBeneficiaryDetails){
      // console.log("this.props.uploadDocumentsLoading");
      spinner = <Spinner />;
    }
        
    // let benificiaries = ["Select"];
    // if (beneficiaryDetails ) {
    //   benificiaries = benificiaries.concat(
    //     beneficiaryDetails &&
    //         beneficiaryDetails
    //           .map((res) => res.patientName)
    //           .filter((val) => val)
    //   )
    // };

    // const result = procedureDetails;
    const procedureOptions: Group[] = procedureDetails.map((procedures) => ({
      // console.log("procedures", procedures);
      items: procedures.procedures.map((procedure) => ({
        value: procedure.procedureId,
        label: procedure.procedure,
      })),
      name: procedures.procedureType,
      type: "group",
      // console.log({ items, name, type });
      // return { items, name, type };
    }));
    let procedureSearch: any;
    if (this.state.formValid && this.state.submitted) {
      procedureSearch = (
        <Questionnaire t={this.props.t} procedureFormData={this.state.procedureFormData} />
      );
    } else {
      procedureSearch = (
        <Container fluid>
          {spinner}
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t('procedureShopper.title')}</h3>
              <Image
                src={cart}
                alt="cart"
                className={classes.stockimage}
                data-test="stockIMG"
              />
            </div>
            <div className="mainContainer">
              <div>
                <div className="text-center">
                  {/* {t('procedureShopper.procedureSearch')} */}
                  <h6 className="bill-heading">{t('procedureShopper.procedureSearch')}</h6>
                </div>
                {/* <div className="form-group">
                  <label className="form-label">Select Beneficiary</label>
                  <Dropdown
                    className="custom-dropdown"
                    options={benificiaries}
                    onChange={(e) => this.beneficiaryHandleChange(e)}
                    value={this.state.beneficiarySelected}
                  />
                  <span className={classes.errorMsg}>
                    {this.state.errorBeneficiarySelected}
                  </span>
                </div> */}
                <SelectOption
                  label={t('procedureShopper.selectpatient')}
                  supportLabel=""
                  options={benificiaries}
                  elementLabelStyle={elementLabelStyle}
                  elementInputStyle={{}}
                  value={this.state.beneficiarySelected}
                  onChange={(e) => this.handleChange(e)}
                  name="beneficiarySelected"
                  errorText={this.state.errorBeneficiarySelected}
                />
                <div className="form-group">
                  <label className="form-label">{t('procedureShopper.procedure')}</label> 
                  <Dropdown
                    className="custom-dropdown"
                    options={procedureOptions}
                    onChange={(e) => this.procedureHandleChange(e)}
                    value={this.state.procedureId}
                  />
                  <span className={classes.errorMsg}>
                    {this.state.errorProcedureId}
                  </span>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    {t('procedureShopper.procedureLocation')}
                  </label>
                  <NumberFormat
                    format="#####"
                    placeholder={t('placeHolder.zipCode')}
                    name="postalCode"
                    value={this.state.postalCode}
                    className="form-control"
                    onChange={(e) => this.handleChange(e)}
                  />
                  <span className={classes.errorMsg}>
                    {this.state.errorPostalCode}
                  </span>
                </div>
                <ButtonAddon
                  label={t('procedureShopper.willingToTravel')}
                  firstBtnLabel="-"
                  secondBtnLabel="+"
                  elementLabelStyle={elementLabelStyle}
                  elementInputStyle={elementInputStyle}
                  onClickPlus={this.handleMinusDistance}
                  onClickMinus={this.handlePlusDistance}
                  name="distance"
                  errorText=""
                  value={this.state.travelDistance}
                  onChange={(e) => this.handleChange(e)}
                  readOnly
                  subtext={t('findProviderPage.Miles')}
                  maxVal={100}
                />
                <Input
                  label={t('procedureShopper.physicianInformation')}
                  supportLabel=""
                  placeholder={t('procedureShopper.physicianName')}
                  elementLabelStyle={elementLabelStyle}
                  elementInputStyle={{}}
                  name="physicianName"
                  errorText={this.state.errorPhysicianName}
                  value={this.state.physicianName}
                  onChange={(e) => this.handleChange(e)}
                />
                <div className="form-group">
                  <NumberFormat
                    format="(###) ###-####"
                    //placeholder={t('procedureShopper.physicianPhoneNumber')}
                    placeholder={t('submitBill.phone')+"(###) ###-####"} 
                    name="physicianPhone"
                    value={this.state.physicianPhone}
                    className="form-control"
                    onChange={(e) => this.handleChange(e)}
                  />
                  <span className={classes.errorMsg}>
                    {this.state.errorPhysicianPhone}
                  </span>
                </div>
                <Input
                  label=""
                  supportLabel=""
                  placeholder={t('procedureShopper.physicianEmail')}
                  elementLabelStyle={elementLabelStyleHide}
                  elementInputStyle={{}}
                  name="physicianEmail"
                  errorText={this.state.errorPhysicianEmail}
                  value={this.state.physicianEmail}
                  onChange={(e) => this.handleChange(e)}
                />
                <div className={classes.flexButtons}>
                  <Button
                    label={t('procedureShopper.backBtn')}
                    clicked={goBackHandler}
                    style={nextBtnStyle}
                    displayImg={false}
                    image=""
                    disabled={false}
                  />
                  <Button
                    label={t('procedureShopper.nextBtn')}
                    clicked={this.handleSubmit}
                    style={nextBtnStyle}
                    displayImg={false}
                    image=""
                    disabled={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </Container>
      );
    }
    return <Fragment>{procedureSearch}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  beneficiaryDetails: state.bbNewUpload.beneficiaryDetails,
  loadingBeneficiaryDetails: state.bbNewUpload.loading,
  procedureDetails: state.procedureDetails.procedureDetails,
});

const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchBalanceBillingBeneficiaryDetails: (userId) =>
    dispatch(procedureActions.fetchBeneficiaryDetails(userId)),
  onFetchProcedureDetails: () =>
    dispatch(procedureActions.fetchProcedureDetails()),
});
export default connect(mapStateToProps, mapDispatchToProps)(ProcedureSearch);
// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProcedureSearch));
